module.exports = __webpack_public_path__ + "static/media/thankYpuSectionImage.6b5735c6.svg";